import React from "react";

function SvgOtherType(props) {
  let blur = "";
  if (props.activeMove) {
    blur = 40;
  }
  return (
    <svg
    style={{verticalAlign:"middle"}}
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      viewBox="0 0 208.419 250.016"
    >
      <g
        id="Group_13516"
        data-name="Group 13516"
        transform="translate(1432.194 -13859.008)"
      >
        <g id="Group_13515" data-name="Group 13515">
          <g
            id="Group_6673"
            data-name="Group 6673"
            transform="translate(-1411.321 13924.106)"
          >
            <path
              id="Path_16567"
              data-name="Path 16567"
              d="M41.923,86.931a10.42,10.42,0,0,1-8.141-3.907L12.952,56.976a10.41,10.41,0,0,1,0-13.016L33.782,17.911A10.417,10.417,0,0,1,50.048,30.927L34.422,50.46,50.048,69.993a10.433,10.433,0,0,1-8.126,16.939Z"
              transform="translate(-10.667 14.654)"
              fill="#d9a4fc"
            />
            <path
              id="Path_16568"
              data-name="Path 16568"
              d="M29.078,86.91a10.414,10.414,0,0,1-8.126-16.923L36.579,50.455,20.953,30.922A10.417,10.417,0,0,1,37.22,17.906L58.049,43.954a10.41,10.41,0,0,1,0,13.016L37.22,83.019A10.453,10.453,0,0,1,29.078,86.91Z"
              transform="translate(106.34 14.674)"
              fill="#d9a4fc"
            />
            <path
              id="Path_16569"
              data-name="Path 16569"
              d="M42.839,87.8A10.42,10.42,0,0,1,32.416,77.373c0-10.891,5.407-21.3,14.829-28.533a8.992,8.992,0,0,0,3.391-7.157C50.636,36.9,47.12,33,42.823,33s-7.813,3.891-7.813,8.688a10.423,10.423,0,0,1-20.845,0c0-16.282,12.845-29.518,28.642-29.518S71.45,25.4,71.45,41.684A29.936,29.936,0,0,1,59.9,65.357c-2.5,1.922-6.688,6.032-6.688,12.016A10.341,10.341,0,0,1,42.839,87.8Z"
              transform="translate(40.499 -12.166)"
              fill="#d9a4fc"
            />
            <circle
              id="Ellipse_565"
              data-name="Ellipse 565"
              cx="10.423"
              cy="10.423"
              r="10.423"
              transform="translate(72.915 91.162)"
              fill="#d9a4fc"
            />
          </g>
        </g>
        <path
          id="Path_16570"
          data-name="Path 16570"
          d="M186.438,102.015H40.585A31.283,31.283,0,0,1,9.333,70.763V29.089a10.423,10.423,0,1,1,20.845,0V70.763A10.43,10.43,0,0,0,40.6,81.186H186.454a10.43,10.43,0,0,0,10.423-10.423V29.089a10.423,10.423,0,1,1,20.845,0V70.763a31.33,31.33,0,0,1-31.283,31.252Z"
          transform="translate(-1441.495 14007.009)"
          fill={"#be63f9"+blur}
        />
        <path
          id="Path_16571"
          data-name="Path 16571"
          d="M207.3,91.333a10.43,10.43,0,0,1-10.423-10.423V39.252a10.43,10.43,0,0,0-10.423-10.423H40.6A10.43,10.43,0,0,0,30.176,39.252V80.927a10.423,10.423,0,1,1-20.845,0V39.252A31.283,31.283,0,0,1,40.583,8H186.436a31.283,31.283,0,0,1,31.252,31.252V80.927A10.36,10.36,0,0,1,207.3,91.333Z"
          transform="translate(-1441.525 13851.008)"
          fill={"#be63f9"+blur}
        />
      </g>
    </svg>
  );
}
export default React.memo(SvgOtherType);
